import { useParams } from "react-router-dom";

export const useGetIdParam = () => {
    const params = useParams();

    const id = params.id;

    if (!id) {
        throw new Error('Id param in not provided');
    };


    const intNumberStringRegex = /^\d+$/;
    const isIntegerString = intNumberStringRegex.test(id);


    if (isIntegerString) {
        return Number(id);
    }

    else {
        return id;
    };
};

